import fetch from '../utils/request'

// 申请手机验证码
export function ApplyVerifyCode(params) {
    return fetch('mall/verifyCode/apply', 'post', params, {
        showLoading: false
    }).then(res => {
        return Promise.resolve(res)
    })
}

// 手机验证码登录
export function LoginMobile(params) {
    return fetch('mall/login/mobile', 'post', params, {
        showLoading: false
    }).then(res => {
        return Promise.resolve(res)
    })
}

// 微信登录
export function LoginWechat(params) {
    return fetch('mall/login/wechat', 'post', params, {
        showLoading: false
    }).then(res => {
        return Promise.resolve(res)
    })
}

// 登出账号
export function LoginOut(params) {
    return fetch('mall/login/out', 'post', params, {
        showLoading: false
    }).then(res => {
        return Promise.resolve(res)
    })
}

// 读取商城商品分类列表
export function GetMallCategoryInfo(params) {
    return fetch('mall/category/list', 'post', params, {
        showLoading: false
    }).then(res => {
        return Promise.resolve(res)
    })
}

// 读取商城商品列表
export function GetMallGoodsInfo(params) {
    return fetch('mall/goods/list', 'post', params, {
        showLoading: true
    }).then(res => {
        return Promise.resolve(res)
    })
}

// 读取商城商品详情
export function GetMallGoodsDetails(params) {
    return fetch('mall/goods/details', 'post', params, {
        showLoading: true
    }).then(res => {
        return Promise.resolve(res)
    })
}

// 获取商城支付token
export function GetPayToken(params) {
    return fetch('mall/pay/token/get', 'post', params, {
        showLoading: false
    }).then(res => {
        return Promise.resolve(res)
    })
}

// 根据token验证是否登录
export function CheckPayToken(params) {
    return fetch('mall/pay/token/check', 'post', params, {
        showLoading: false
    }).then(res => {
        return Promise.resolve(res)
    })
}

// 读取账户基本信息
export function GetAccountName(params) {
    return fetch('mall/account/base/info', 'post', params, {
        showLoading: false
    }).then(res => {
        return Promise.resolve(res)
    })
}

// 读取账户资金信息
export function GetMoneyInfo(params) {
    return fetch('mall/account/money/info', 'post', params, {
        showLoading: false
    }).then(res => {
        return Promise.resolve(res)
    })
}

// 微信H5支付
export function WxH5Pay(params) {
    return fetch('mall/wx/pay', 'post', params, {
        showLoading: false
    }).then(res => {
        return Promise.resolve(res)
    })
}

//微信授权获取用户信息
export function GetWxUserInfo(params) {
    return fetch('mall/wx/userinfo/get', 'post', params, {
        showLoading: false
    }).then(res => {
        return Promise.resolve(res)
    })
}

//微信H5授权登录
export function WxH5Login(params) {
    return fetch('mall/wx/login', 'post', params, {
        showLoading: false
    }).then(res => {
        return Promise.resolve(res)
    })
}

//获取微信登录接口配置信息
export function GetWxLoginSetting(params) {
    return fetch('mall/wx/login/setting', 'post', params, {
        showLoading: true
    }).then(res => {
        return Promise.resolve(res)
    })
}
